/**
 *
 * Header.js
 *
 * bladsfasdfas
 */
import GreenLogo from '../../image/gogochart_greenlogo.png';
import Avatar from '../../image/avatar.png';
import Dropdown, {
  DropdownMenu,
  MenuItem
} from '../../components/uielements/dropdown';
import Button from '../../components/uielements/button';

import React from 'react';
import { Wrapper, PrimaryWrapper } from './Wrapper';

import HeaderLogo from "../../components/Headers/Logo";
import HeaderMenu from "../../components/Headers/Menu";
import HeaderLogin from "../../components/Headers/LoginButton/index";

function Header(props) {
  const handleMenuClick = ( event ) => {
    console.log( event)

    switch ( event.key){
      case "account":
        props.history.push(`${'/me/account'}`)
        break;
      case "billing":
        props.history.push(`${'/me/billing'}`)
        break;

      case "logout":
        props.auth.logout();

        break;

      default:

        break;
    }
  }
  const menu = (
    <DropdownMenu className="accDropDown" onClick={ handleMenuClick }>
      <MenuItem className="accDropDownMenuItem" key="account">{ "My account" }</MenuItem>
      <MenuItem className="accDropDownMenuItem" key="billing">{ "Billing Info" }</MenuItem>
      <MenuItem className="accDropDownMenuItem" key="logout">{ "Logout" }</MenuItem>
    </DropdownMenu>
  );

  const { isAuthenticated } = props.auth;

  return (
    <Wrapper>
      <div className="header">
          <div className="header-row">
            <HeaderLogo isClickable={true} history={props.history} />

            {
              props.auth.isAuthenticated() && (
                <HeaderMenu history={props.history} auth={props.auth}/>
              ) || (
                <HeaderLogin history={props.history}>SIGN UP / LOGIN</HeaderLogin>
              )
            }
          </div>
        </div>
    </Wrapper>
  );
}
export default Header;

{/* <div className="logo"
  onClick={ () => props.history.push(`${'/'}`) }> 
  <img src={process.env.PUBLIC_URL + GreenLogo} />
</div>

<nav>
  {
    isAuthenticated() && (
      <div>
        <div>
          { "HI GoGoChart"}
        </div>
        <Dropdown overlay={menu} trigger={['click']}>
          <div>
            <img
              className="avatarIcon"
              src={process.env.PUBLIC_URL + Avatar}
            />

            <div className="nav-bars">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </Dropdown>
      </div>
    )
  }
  {
    !isAuthenticated() && (
      <Button  
        onClick={ () => this.props.history.push(`${'/home'}`) } 
        type="primary" 
        className="loginSignUp">
        {/* <Button  onClick={this.login.bind(this)} type="primary" className="loginSignUp"> * /}
        SIGN UP / LOGIN
      </Button>
    )
  }
</nav> */}


// WEBPACK FOOTER //
// ./src/components/Header/index.js